
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { StaffMemberServiceListAction } from '../../redux/Action/StaffMemberAction';
import { capitalizeFirstLetter } from '../../utils/Helper';
import { Config } from '../../config/Config';


const StaffMember = ({ handleSelectedStaffMember, data, staffData, watch ,dataIndex}: any) => {
    const dispatch = useDispatch<any>();
    const profileData = useSelector((state: any) => state.GetProfileState);

    const staffMemberData = useSelector((state: any) => state.StaffMemberServiceListState);
    const [staffMember, setStaffMember]: any = useState([]);
    const [selectedStaffMember, setSelectedStaffMember]: any = useState('');



    const role_id = Config?.USER_DETAILS?.role_id
    const staffLoginId = Config?.USER_DETAILS?.id



    // useEffect(() => {
    //     if (staffData) {
    //         staffData?.map((item: any) => {
    //             selectedStaffMember.push(item?.staff_id)
    //         })
    //     }
    // }, [staffData]);


    useEffect(() => {
        const payload = { "page": 0, "pageSize": 10, "parent_id": profileData?.data?.data?.id ? profileData?.data?.data?.id : "", "search": "" }
        dispatch(StaffMemberServiceListAction(payload))
    }, [profileData]);


    useEffect(() => {
        if (staffMemberData?.data?.data?.length > 0) {
            setStaffMember(staffMemberData?.data?.data)
        }
    }, [staffMemberData]);


    const handleCheckboxChange = (id: any) => {
        setSelectedStaffMember(id)
        // setSelectedStaffMember((prevSelectedCategories: any) => {
        //     if (prevSelectedCategories.includes(id)) {
        //         return prevSelectedCategories.filter((categoryId: any) => categoryId !== id);
        //     } else {
        //         return [...prevSelectedCategories, id];
        //     }
        // });
    };



    const [arrNew, setArrNew] = useState<any[]>([]);

    useEffect(() => {
        if (staffData?.length > 0) {
            const updatedArrNew = staffData.map((item: any) => item?.staff_id);
            setArrNew(updatedArrNew);
        }

    }, [staffData]);

    useEffect(() => {
        if (arrNew.length > 0) {
            setSelectedStaffMember(arrNew)
        }
    }, [arrNew])

    useEffect(() => {
        handleSelectedStaffMember(selectedStaffMember, data)
    }, [selectedStaffMember])



    useEffect(() => {
        return () => {
            dispatch(StaffMemberServiceListAction("RESET"))
        }
    }, [])

    useEffect(() => {

    }, [selectedStaffMember])

    return (
        <>
            {role_id == 2 ? (
                staffMember?.length > 0 && staffMember.map((item: any, index: any) => {
                    return item?.id == staffLoginId ? (
                        <li key={item?.id}>
                            <input
                                type="radio"
                                className="btn-check"
                                id={`option_item_${index}_${data?.id}`}
                                name={`RadioButton-${dataIndex}`}
                                onChange={() => handleCheckboxChange(item?.id)}
                                // checked={item?.id == staffLoginId}
                            />
                            <label htmlFor={`option_item_${index}_${data?.id}`}>
                                <figure>
                                    <img
                                        src={item?.profile_pic || "images/fely-beauty.jpg"}
                                        alt={`Staff ${index}`}
                                        onError={(e: any) => (e.target.src = "images/fely-beauty.jpg")}
                                    />
                                    <span className="icon-check"></span>
                                </figure>
                                <p>{capitalizeFirstLetter(item?.owner_name)}</p>
                            </label>
                        </li>
                    ) : '';
                })
            ) : (
                staffMember?.length > 0 && staffMember.map((item: any, index: any) => (
                    <li key={item?.id}>
                        <input
                            type="radio"
                            className="btn-check"
                            id={`option_item_${index}_${data?.id}`}
                            name={`RadioButton-${dataIndex}`}
                            onChange={() => handleCheckboxChange(item?.id)}
                        />
                        <label htmlFor={`option_item_${index}_${data?.id}`}>
                            <figure>
                                <img
                                    src={item?.profile_pic || "images/fely-beauty.jpg"}
                                    alt={`Staff ${index}`}
                                    onError={(e: any) => (e.target.src = "images/fely-beauty.jpg")}
                                />
                                <span className="icon-check"></span>
                            </figure>
                            <p>{capitalizeFirstLetter(item?.owner_name)}</p>
                        </label>
                    </li>
                ))
            )}
        </>
    )

}
export default React.memo(StaffMember)